// eslint-disable-next-line import/prefer-default-export
export const pageTypes = {
  addToCartPage: 'add_to_cart_page',
  cartPage: 'cart_page',
  categorySplashPage: 'category_page',
  categoryUnavailablePage: 'category_page',
  homePage: 'home_page',
  itemPage: 'item_page',
  purchaseCompletePage: 'purchase_complete_page',
  registryZeroSearchResultsPage: 'search_page',
  unavailableItemPage: 'item_page',
  wishListPage: 'wish_list_page',
  zeroSearchResultsPage: 'search_page',
  searchPage: 'search_page',
  browsePage: 'browse_page',
  orderDetailsPage: 'order_details_page',
  storePurchaseDetailsPage: 'store_purchase_details_page',
  accountDashboardPage: 'account_dashboard_page',
  registryPage: 'registry_page',
  purchaseHistoryPage: 'purchase_history_page',
  purchaseTrackingPage: 'purchase_tracking_page',
};
